import { lazy, Suspense, type FC, type ComponentProps } from 'react';
import { graphql, createFragmentContainer } from 'react-relay/legacy';

import { type PdpSharedDealerDetailsBioModalLazy_seller$data as Seller } from './__generated__/PdpSharedDealerDetailsBioModalLazy_seller.graphql';

const LazyComponent = lazy(
    () =>
        import(
            /* webpackChunkName: "PdpSharedDealerDetailsBioModal" */ './PdpSharedDealerDetailsBioModal'
        )
);

export const PdpSharedDealerDetailsBioModalLazyComponent: FC<
    Omit<ComponentProps<typeof LazyComponent>, 'seller'> & { seller: Seller }
> = props => (
    <Suspense fallback={null}>
        <LazyComponent {...props} />
    </Suspense>
);

export const PdpSharedDealerDetailsBioModalLazy = createFragmentContainer(
    PdpSharedDealerDetailsBioModalLazyComponent,
    {
        seller: graphql`
            fragment PdpSharedDealerDetailsBioModalLazy_seller on Seller
            @argumentDefinitions(isExtended: { type: "Boolean", defaultValue: false }) {
                ...PdpSharedDealerDetailsBioModal_seller @arguments(isExtended: $isExtended)
            }
        `,
    }
);
